'use strict';

angular.module('dekky.forms.themes.bootstrap')
	.run(function($templateCache) {
		$templateCache.put('/dekky.forms/themes/bootstrap/fields/radioCollection.html',
			'<div class="form-group" ng-repeat="item in field.items">' +
				'<label class="form__radio">' +
					'<input class="form__radio" name="{{ field.name }}" type="radio" ng-model="model" ng-value="item" id="{{ field.name + \'_\' + $index }}">' +
					'<span class="form__radio_text">{{ item[field.radio.label] }}</span>' +
				'</label>' +
			'</div>'
		);
	});